import {z} from 'zod'

export type Percentage = `${number}%`

export const UserType = z.enum(['citizen', 'operator'])
export type UserType = z.infer<typeof UserType>
